export function objectToUriString(value: object) {
    return Object.entries(value).map(([key, v]) => `${key}${v ? `=${v}` : ''}`).join('&');
}
